import { Alert, AlertType, Button } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import React, { useEffect, useState } from 'react'
import { configClient } from '@egw/config'
import { type Config } from '../../config/config'

export const BrowserErrorPage: React.FC = () => {
  const { t } = useTranslation('features-auth')
  const [copied, setCopied] = useState<boolean>(false)
  const { globalBaseUrl } = configClient.getConfig() as Config

  const handleCopy = (): void => {
    void window.navigator.clipboard.writeText(globalBaseUrl)
    setCopied(true)
  }

  useEffect(() => {
    if (copied) {
      const timeout = setTimeout(() => {
        setCopied(false)
      }, 3000)
      return () => {
        clearTimeout(timeout)
      }
    }
  }, [copied])

  return (
    <div className="egw-container text-center mt-5xl">
      <h1 className="typo-primary-5xl-light mb-md">{t('in_app_browser.heading')}</h1>
      <div className="typo-primary-base mb-3xl">{t('in_app_browser.description')}</div>
      <div className="typo-primary-base p-md bg-light flex flex-col items-center mb-3xl">
        <div className="text-text-meta mb-md">{t('in_app_browser.copy_cta')}</div>
        <Button onClick={handleCopy}>{t('in_app_browser.copy_link')}</Button>
      </div>

      {copied ? (
        <div className="w-full">
          <Alert className="w-fit m-auto" alertType={AlertType.Success} description={t('in_app_browser.link_copied')} />
        </div>
      ) : null}
    </div>
  )
}
